import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MainRoute from "./routes";
import AuthState from "./context/context";
import Sidebar from "./component/Sidebar/SideBar";

function App() {
  
  return (
    <div className="App">
      <AuthState>
        <MainRoute />
      </AuthState>
    </div>
  );
}

export default App;
